import { type VariantProps, cva } from "class-variance-authority";
export const inputVariants = cva(
  "peer w-full border bg-transparent transition-[border] focus:outline-none rounded-none",
  {
    variants: {
      variant: {
        default:
          "placeholder:text-sm placeholder:text-black-60 opacity-100 placeholder:font-normal",
        floating: "placeholder:text-transparent",
      },
      size: {
        default: "h-11 py-3.5",
        sm: "h-10 py-2.5",
      },
      color: {
        default: "border-primary focus:border-primary text-primary",
        white: "border-white focus:border-white text-white",
        error: "border-red ring-1 ring-red",
        errorOrange: "border-orange-600 ring-1 ring-orange-600 text-white",
      },
    },
    compoundVariants: [
      {
        size: "default",
        variant: "floating",
        class:
          "focus:pt-5 focus:pb-2 [&:not(:placeholder-shown)]:pt-5 [&:not(:placeholder-shown)]:pb-2",
      },
      {
        size: "sm",
        variant: "floating",
        class:
          "focus:pt-3.5 focus:pb-2 [&:not(:placeholder-shown)]:pt-3.5 [&:not(:placeholder-shown)]:pb-1",
      },
    ],
    defaultVariants: {
      size: "default",
      variant: "default",
      color: "default",
    },
  },
);

export type InputVariants = VariantProps<typeof inputVariants>;
